import Vue from 'vue'
import Vuex from 'vuex'
import {vuex as app} from '../app'
import * as TYPES from './types'
import baseConfig from '../config'
import {setToken} from '../http'

import {set, clear} from '@utils/storage'

import {isEmpty} from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: {
      apiPath: baseConfig.basePath,
      apiImagesPath: baseConfig.basePath + 'images/'
    },
    user: {},
    permissions: [],
    roles: [],
    token: '',
    isLoading: false,
    collapseMenu: false,
    listStore: {
      init: {},
      listOriginalData: [],
      listData: [],
      listTotal: 0,
      listPerPage: 20,
      listCurrentPage: 1,
      listFilters: {}
    }
  },
  mutations: {
    [TYPES.COLLAPSE_MENU] (state, value) {
      state.collapseMenu = value
    },
    [TYPES.LOADER_SHOW] (state, value) {
      state.isLoading = value
    },
    [TYPES.LIST_INIT] (state, payload) {
      state.listStore.init = payload
    },
    [TYPES.LIST_ORIGINAL_DATA] (state, payload) {
      state.listStore.listOriginalData = payload
    },
    [TYPES.LIST_DATA] (state, payload) {
      state.listStore.listData = payload
    },
    [TYPES.LIST_TOTAL] (state, payload) {
      state.listStore.listTotal = payload
    },
    [TYPES.LIST_PER_PAGE] (state, payload) {
      state.listStore.listPerPage = payload
    },
    [TYPES.LIST_CURRENT_PAGE] (state, payload) {
      state.listStore.listCurrentPage = payload
    },
    [TYPES.LIST_FILTERS] (state, payload) {
      state.listStore.listFilters = payload
    },
    [TYPES.AUTH_USER] (state, payload) {
      state.user = payload
    },
    [TYPES.AUTH_PERMISSIONS] (state, payload) {
      state.permissions = payload
    },
    [TYPES.AUTH_ROLES] (state, payload) {
      state.roles = payload
    },
    [TYPES.AUTH_TOKEN] (state, payload) {
      setToken(payload)
      state.token = payload
    }
  },
  actions: {
    showLoader: (context) => {
      context.commit(TYPES.LOADER_SHOW, true)
    },
    setCollapseMenu: (context, payload) => {
      context.commit(TYPES.COLLAPSE_MENU, payload)
    },
    hideLoader: (context) => {
      setTimeout(() => {
        context.commit(TYPES.LOADER_SHOW, false)
      }, 500)
    },
    setListInit: (context, payload) => {
      return new Promise((resolve) => {
        context.commit(TYPES.LIST_INIT, payload.init)
        context.commit(TYPES.LIST_ORIGINAL_DATA, payload.data)
        context.commit(TYPES.LIST_DATA, payload.data)
        resolve()
      })
    },
    setListOriginalData: (context, payload) => {
      return new Promise((resolve) => {
        context.commit(TYPES.LIST_ORIGINAL_DATA, payload)
        resolve()
      })
    },
    setListData: (context, payload) => {
      context.commit(TYPES.LIST_DATA, payload)
    },
    setListTotal: (context, payload) => {
      context.commit(TYPES.LIST_TOTAL, payload)
    },
    setListPerPage: (context, payload) => {
      context.commit(TYPES.LIST_PER_PAGE, payload)
    },
    setListCurrentPage: (context, payload) => {
      context.commit(TYPES.LIST_CURRENT_PAGE, payload)
    },
    setListFilters: (context, payload) => {
      context.commit(TYPES.LIST_FILTERS, payload)
    },
    login: (context, payload) => {
      return new Promise((resolve) => {
        set('user', payload.user)
        set('permissions', payload.permissions)
        set('roles', payload.roles)
        set('token', payload.token)
        context.commit(TYPES.AUTH_USER, payload.user)
        context.commit(TYPES.AUTH_PERMISSIONS, payload.permissions)
        context.commit(TYPES.AUTH_ROLES, payload.roles)
        context.commit(TYPES.AUTH_TOKEN, payload.token)
        resolve()
      })
    },
    logout: (context, payload) => {
      return new Promise((resolve) => {
        clear()
        context.commit(TYPES.AUTH_USER, {})
        context.commit(TYPES.AUTH_PERMISSIONS, [])
        context.commit(TYPES.AUTH_ROLES, [])
        context.commit(TYPES.AUTH_TOKEN, '')
        resolve()
      })
    }
  },
  getters: {
    config: ({config}) => config,
    isLogged: ({token}) => !isEmpty(token),
    token: ({token}) => token,
    currentUser: ({user}) => user,
    permissions: ({permissions}) => permissions,
    roles: ({roles}) => roles,
    isLoading: ({isLoading}) => isLoading,
    listStore: ({listStore}) => listStore,
    collapseMenu: ({collapseMenu}) => collapseMenu
  },
  modules: {
    ...app
  }
})



// WEBPACK FOOTER //
// ./src/vuex/index.js